// eslint-disable-next-line no-restricted-imports
import NextLink, { LinkProps } from 'next/link';
import { AnchorHTMLAttributes } from 'react';

/** A `next/Link` with predefined values */
const Link = (
  props: Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & LinkProps & { children?: React.ReactNode },
) => (
  // Prefetch = false, so every page would not preload the link,
  // but on hover, it will prefetch the link.
  <NextLink prefetch={true} {...props}>
    {props.children}
  </NextLink>
);

export default Link;
